"use client";

import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from "@tanstack/react-query";
import { type PropsWithChildren, useEffect, useState } from "react";
import { getTrialErrorCode, type TrialErrorCode } from "@/lib/trialError";
import { TrialErrorModal } from "./TrialErrorModal";
export function TrialErrorListener(t0) {
  const $ = _c(9);
  const {
    children
  } = t0;
  const queryClient = useQueryClient();
  const [trialErrorCode, setTrialErrorCode] = useState(null);
  let t1;
  let t2;
  if ($[0] !== queryClient) {
    t1 = () => {
      const unsubscribe = queryClient.getMutationCache().subscribe(event => {
        const code = getTrialErrorCode(event);
        if (code) {
          setTrialErrorCode(code);
        }
      });
      return unsubscribe;
    };
    t2 = [queryClient];
    $[0] = queryClient;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setTrialErrorCode(null);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== trialErrorCode) {
    t4 = <TrialErrorModal errorCode={trialErrorCode} onClose={t3} />;
    $[4] = trialErrorCode;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children || $[7] !== t4) {
    t5 = <>{children}{t4}</>;
    $[6] = children;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}